import DatricRequests from '../datric.requests';
import { ApiKey, CreateApiKeyPayload } from '../../../models/apiKey.model';

const requests = new DatricRequests();

export async function createApiKey(userId: string, payload: CreateApiKeyPayload): Promise<ApiKey> {
	return requests.post(`users/${userId}/api-keys`, payload);
}

export async function listApiKeys(userId: string): Promise<ApiKey[]> {
	return requests.get(`users/${userId}/api-keys`);
}

export async function listAllApiKeys(): Promise<ApiKey[]> {
	return requests.get('api-keys');
}

// Chaves do próprio usuário autenticado (com consumo).
export async function listMyApiKeys(): Promise<ApiKey[]> {
	return requests.get('me/api-keys');
}

export async function updateApiKeyPrice(id: string, pricePerQuery: number | null): Promise<ApiKey> {
	return requests.patch(`api-keys/${id}/price`, { pricePerQuery });
}

export async function deleteApiKey(id: string): Promise<void> {
	return requests.delete(`api-keys/${id}`);
}
